import { Box, Flex, Card, Link } from '@cowsquare/design';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Advertisements } from '../../Advertisements';
import { Section } from '../../Section';
import { Title } from '../../Title';
import { LinkCardListLoading, Loading } from '../../Loading';

const SubTitle = styled.h3`
  font-size: 16px;
  line-height: 1.5;
  font-weight: normal;
  margin: 0;
`;

const CardFlex = styled(Flex).attrs({
  flexWrap: 'wrap',
})`
  margin: 0 -8px;
`;

const CardBox = styled(Box).attrs({
  width: [1, 1 / 3],
  px: 4,
  pb: 5,
})``;

const GET_DOWNLOADS = gql`
  query {
    hkdutest_user_downloads_categories {
      id
      name
      downloads {
        id
        name
        file {
          name
          link
        }
      }
    }
  }
`;

const Downloads = () => {
  return (
    <Section>
      <Helmet>
        <title>Downloads - HKDU Public</title>
      </Helmet>
      <Advertisements
        ads={[
          {
            href: 'http://google.com',
            title: 'Title',
            description: 'Description',
            imgUrl:
              'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
          },
        ]}
      />
      <Box width="100%" px={['20px', 0]} py={8}>
        <Flex flexDirection="column">
          <Title>Downloads</Title>
          <Query query={GET_DOWNLOADS}>
            {({ data, loading }) => {
              if (loading) {
                return (
                  <React.Fragment>
                    <Box mt={25} mb={20}>
                      <Loading width="120px" height="12px" />
                    </Box>
                    <LinkCardListLoading />
                  </React.Fragment>
                );
              }
              return R.pipe(
                R.propOr([], 'hkdutest_user_downloads_categories'),
                R.map(category => (
                  <React.Fragment key={category.id}>
                    <Box mt={25} mb={20}>
                      <SubTitle>{category.name}</SubTitle>
                    </Box>
                    <CardFlex>
                      {R.pipe(
                        R.propOr([], 'downloads'),
                        R.map(download => (
                          <CardBox key={download.id}>
                            <Card height="120px" as="div">
                              <Card.Meta title={download.name}>
                                <Link.Group>
                                  <Link icon="ATTACHMENT" href={R.pathOr('', ['file', 'link'], download)}>
                                    {R.pathOr('', ['file', 'name'], download)}
                                  </Link>
                                </Link.Group>
                              </Card.Meta>
                            </Card>
                          </CardBox>
                        ))
                      )(category)}
                    </CardFlex>
                  </React.Fragment>
                ))
              )(data);
            }}
          </Query>
        </Flex>
      </Box>
    </Section>
  );
};

export default Downloads;
